// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1rO-4","form":"styles_form__35Jte"};